import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import { useTranslation } from 'react-i18next';
import WagonProductList from '../WagonDetailsPage/WagonProductList/WagonProductList';

import useStyles from './styles';

export default function WagonDetails(props) {
  const classes = useStyles();

  const { wagon, expanded, handleChange } = props;
  const { t } = useTranslation();

  return (
    <div>
      <Accordion
        className={classes.accordion}
        expanded={expanded}
        onChange={handleChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
        >
          <Typography className={classes.heading}>
            {' '}
            {t('Wagon details')}
          </Typography>
          <Typography className={classes.secondaryHeading}>
            {t('All wagon technical details available')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'block' }}>
          <div className={classes.container}>
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={3}>
                <FormLabel className={classes.formLabel}>
                  {t('Next revision date')}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.formLabel}> {t('ecm')}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {t('Contract number')}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {t('Length over buffers')} (mm)
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.formLabel}>GPS</FormLabel>
              </Grid>

              <Grid item xs={3}>
                <FormLabel className={classes.wagonDetail}>
                  {' '}
                  {wagon?.nextRevision}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.wagonDetail}>
                  {wagon?.ecm}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <FormLabel className={classes.wagonDetail}>
                  {' '}
                  {wagon?.contractNumber}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                <FormLabel className={classes.wagonDetail}>
                  {wagon?.lengthOverBuffers}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.wagonDetail}>
                  {t(wagon?.gps)}{' '}
                </FormLabel>
              </Grid>
            </Grid>
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={3}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {t('Next tank test')}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {' '}
                  {t('TANKCODE')}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {t('tara')} (t)
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {t('Max gross weight')} (t)
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.formLabel}>
                  {t('volume')} (m3)
                </FormLabel>
              </Grid>

              <Grid item xs={3}>
                <FormLabel className={classes.wagonDetail}>
                  {' '}
                  {wagon?.nextTankTest}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.wagonDetail}>
                  {wagon?.tankCode}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <FormLabel className={classes.wagonDetail}>
                  {wagon?.tara}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={3}>
                {' '}
                <FormLabel className={classes.wagonDetail}>
                  {wagon?.maxGrossWeight}{' '}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                {' '}
                <FormLabel className={classes.wagonDetail}>
                  {wagon?.volume}{' '}
                </FormLabel>
              </Grid>
            </Grid>
          </div>
          <Grid container spacing={0} alignItems="center" justify="center">
            <WagonProductList products={wagon?.products} />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
